import { compose, withProps } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import Link from 'react-router/lib/Link';

import withCanViewWaitingList from '../../../../common/hoc/withCanViewWaitingList';
import { isBarberUser } from '../../../../auth/selectors';
import { getCustomersWaitingForBarber } from '../../../waitingList/waitingListCustomers/selectors';
import config from '../../../../../config';
import { getDate } from '../../appointmentSelector';
import { getServiceDuration } from '../../../services/selector';
import NextAvailableTime from './NextAvailableTime';
import HoverMenu from '../../../../common/HoverMenu';
import BarberHoverMenuTimeTracking from '../../../timeTracker/containers/BarberHoverMenuTimeTracking';
import withPermissions from '../../../../auth/utils/withPermissions';

const BarberMenu = ({
  barberId,
  duration,
  date,
  customersWaiting,
  barberUser,
  canViewWaitingList,
  canViewBarberProfile,
}) => (
  <ul className="list-bare" data-automation-id={`hoverMenu:${barberId}`}>
    <li className="c-hovermenu__item" display-if={canViewBarberProfile}>
      <Link
        data-automation-id={`hoverMenu:barberProfile:${barberId}`}
        className="c-btn"
        to={barberUser ? '/barber/profile' : `/barbers/${barberId}`}
      >
        Barber profile
      </Link>
    </li>
    <li className="c-hovermenu__item" display-if={canViewWaitingList && customersWaiting}>
      <Link
        data-automation-id={`hoverMenu:waitingList:${barberId}`}
        className="c-btn"
        to={barberUser ? `/barber/profile/waiting-list?date=${date}` : `/barbers/${barberId}/waiting-list?date=${date}`}
      >
        Waiting list
      </Link>
    </li>
    <li className="c-hovermenu__item">
      <NextAvailableTime barberId={barberId} duration={duration} fromDateTime={date} />
    </li>
    <li className="c-hovermenu__item">
      <BarberHoverMenuTimeTracking barberId={barberId} />
    </li>
  </ul>
);
BarberMenu.propTypes = {
  barberId: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  customersWaiting: PropTypes.number.isRequired,
  barberUser: PropTypes.bool.isRequired,
  canViewWaitingList: PropTypes.bool.isRequired,
  canViewBarberProfile: PropTypes.bool.isRequired,
};

const BarberHoverMenu = ({
  barber,
  children,
  duration,
  date,
  customersWaiting,
  barberUser,
  canViewWaitingList,
  canViewBarberProfile,
}) => (
  <HoverMenu
    menu={
      <BarberMenu
        barberId={barber.id}
        duration={duration}
        date={date}
        customersWaiting={customersWaiting}
        barberUser={barberUser}
        canViewWaitingList={canViewWaitingList}
        canViewBarberProfile={canViewBarberProfile}
      />
    }
  >
    {children}
  </HoverMenu>
);
BarberHoverMenu.propTypes = {
  barber: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  duration: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  customersWaiting: PropTypes.number.isRequired,
  barberUser: PropTypes.bool.isRequired,
  canViewWaitingList: PropTypes.bool.isRequired,
  canViewBarberProfile: PropTypes.bool.isRequired,
};

export default compose(
  connect((state, ownProps) => {
    const duration = getServiceDuration(state, ownProps.barber.defaultServiceId) || config.defaultMinServiceLen;
    const date = getDate(state);
    return {
      customersWaiting: getCustomersWaitingForBarber(state, ownProps.barber.id, date),
      barberUser: isBarberUser(state),
      duration,
      date,
    };
  }),
  withCanViewWaitingList,
  withPermissions,
  withProps(props => ({
    canViewBarberProfile: props.permissions.barbers.view,
  }))
)(BarberHoverMenu);
